<template>
  <div class="order-product">
    {{ cartTotalText }}
    <div class="product-list">
      <!-- 购物车 -->
      <div class="product-wrap" v-if="openShoppingCart && isCart">
        <div
          class="product-item"
          v-for="(item, index) in showCartList"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID"
        >
          <div class="detail-wrap" v-if="item.isExtra">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(item)"
                :gifts="[showExtraIcon]"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ showExtraName }}
                </p>
                <p class="product-num">* {{ cartTotalExtraCoin }}</p>
              </div>
              <div class="product-price extra-gift">
                ({{ letter.v3ExtraGift }})
              </div>
            </div>
          </div>
          <div class="detail-wrap" v-else>
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(item)"
                :gifts="getGiftIcons(item)"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ getProductName(item) }}
                </p>
                <p class="product-num">* {{ item.quantity }}</p>
              </div>
              <div
                class="product-price"
                v-if="
                  item.amountLevel &&
                  item.amountLevel.TRANS_AMOUNT &&
                  item.amountLevel.SHOW_CURRENCY
                "
              >
                {{ item.amountLevel.TRANS_AMOUNT }}
                {{ item.amountLevel.SHOW_CURRENCY }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-wrap" v-else>
        <!-- 直接购买 -->
        <div
          class="product-item"
          :key="curProduct.PRODUCT_ID + curProduct.CP_PRODUCT_ID"
        >
          <div class="detail-wrap">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(curProduct)"
                :gifts="getGiftIcons(curProduct)"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ getProductName(curProduct) }}
                </p>
                <p class="product-num">* 1</p>
              </div>
              <div
                class="product-price"
                v-if="
                  curProduct.amountLevel &&
                  curProduct.amountLevel.TRANS_AMOUNT &&
                  curProduct.amountLevel.SHOW_CURRENCY
                "
              >
                {{ curProduct.amountLevel.TRANS_AMOUNT }}
                {{ curProduct.amountLevel.SHOW_CURRENCY }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="product-item"
          v-for="(item, index) in extraList"
          :key="index"
        >
          <div class="detail-wrap">
            <div class="left">
              <gift-icon
                class="product-icon"
                :background="getGiftBanckground(curProduct)"
                :gifts="[item.ICON]"
              ></gift-icon>
            </div>
            <div class="right">
              <div class="top-bar flex-between">
                <p class="product-name">
                  {{ item.NAME }}
                </p>
                <p class="product-num">* {{ item.COUNT }}</p>
              </div>
              <div class="product-price extra-gift" v-if="item.isExtra">
                ({{ letter.v3ExtraGift }})
              </div>
              <div
                class="product-price extra-gift"
                v-if="item.isProductDoubleExtra"
              >
                ({{ letter.v3FirstTopUpGiveaway }})
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Icon
      class="fold-icon"
      :class="{ active: !fold }"
      name="double-down"
      v-show="showFold"
      @click="handleFoldState"
    ></Icon>
  </div>
</template>

<script>
import productName from '@mixins/product';
import product from '@mixins/officialTopup/product';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';
import { mapState, mapGetters } from 'vuex';
import { popupType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
import extra from '@mixins/officialTopup/extra';
import icon from '@mixins/officialTopup/icon';
export default {
  name: 'OrderProduct',
  mixins: [productName, product, cartAddAndDetail, extra, icon],
  props: {
    curProduct: {
      type: Object,
      default: () => {}
    },
    curPriceSubCoin: {
      type: Number,
      default: 0
    },
    curPriceExtraCoin: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fold: true,
      isLandscape: window.innerWidth > window.innerHeight
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      openShoppingCart: state => state.page.openShoppingCart
    }),
    ...mapGetters(['cartTotalExtraCoin', 'isCart']),
    cartTotalText() {
      const num =
        this.openShoppingCart && this.isCart ? this.cartTotalQuantity : 1;
      return this.letter.v3TotalNProducts.replace('${n}', num);
    },
    showFold() {
      if (this.hasExtra) {
        return this.cartList.length >= 2;
      }
      return this.cartList.length > 2;
    },
    hasExtra() {
      return (
        this.showExtraIcon &&
        this.cartTotalExtraCoin > 0 &&
        this.cartList?.length
      );
    },
    showCartList() {
      let list = [...this.cartList];
      if (this.hasExtra) {
        list.push({
          isExtra: true,
          ...this.cartList[this.cartList.length - 1],
          PRODUCT_ID: new Date().getTime(),
          CP_PRODUCT_ID: new Date().getTime()
        });
      }
      // 移动端全部展示 PC端折叠展示前两个商品
      if (this.isLandscape) {
        return list.slice(0, this.fold ? 2 : list.length);
      }

      return list;
    },
    extraList() {
      if (!this.showExtraIcon) {
        return [];
      }
      let list = [];
      const productExtraCoin = this?.curProduct?.PRODUCT_EXTRA_COIN;
      // 商品加码、首充优惠
      if (productExtraCoin && +productExtraCoin > 0) {
        list.push({
          ID: new Date().getTime(),
          COUNT: productExtraCoin,
          NAME: this.showProductExtraCoinName,
          ICON: this.showProductExtraCoinIcon,
          TRANS_AMOUNT: productExtraCoin,
          isProductDoubleExtra: true
        });
      }
      // 渠道拆单游戏币
      if (this.curPriceSubCoin > 0) {
        list.push({
          ID: new Date().getTime(),
          COUNT: this.curPriceSubCoin,
          NAME: this.showSubCoinName,
          ICON: this.showSubCoinIcon,
          TRANS_AMOUNT: this.curPriceSubCoin,
          isExtra: true
        });
      }
      // 渠道加码
      if (this.curPriceExtraCoin > 0) {
        list.push({
          ID: new Date().getTime(),
          COUNT: this.curPriceExtraCoin,
          NAME: this.showExtraName,
          ICON: this.showExtraIcon,
          TRANS_AMOUNT: this.curPriceExtraCoin,
          isExtra: true
        });
      }
      return list;
    }
  },
  methods: {
    handleFoldState() {
      this.fold = !this.fold;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';

//商品icon
::v-deep .icon-container {
  border-radius: 20px;
  .icon {
    width: 55px;
    height: 55px;
  }
}

.order-product {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: $moduleBackgroundColor;
  padding: 16px 20px;
  font-size: 24px;
  color: #333333;
}

.product-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 30px;
  line-height: 1.5;
  margin-top: 20px;
  .product-wrap {
    display: flex;
    overflow-x: scroll;
    scrollbar-width: none;

    .product-item {
      border-radius: 20px;
      box-sizing: border-box;
      .detail-wrap {
        display: flex;
        align-items: center;
        flex-direction: column;
        .left {
          width: 251px;
          height: 89px;
          .product-icon {
            width: 251px;
            height: 89px;
          }
        }
        .right {
          flex: 1;
          word-break: break-word;
          font-size: 22px;
          text-align: center;
          .top-bar {
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            line-height: 1.5;
            .product-num {
              flex-shrink: 0;
              margin-left: 10px;
            }
          }
          .product-price {
            display: none;
          }
        }
      }
    }
    .product-item + .product-item {
      margin-left: 20px;
    }
  }
}

.fold-icon {
  display: none;
}
.extra-wrap {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 10px 10px 40px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 20px;
  .product-icon {
    flex-shrink: 0;
    width: 55px;
    margin-right: 20px;
  }
}
.extra-gift {
  color: red !important;
}

@media screen and (orientation: landscape) {
  .product-list {
    .product-wrap {
      display: flex;
      flex-direction: column;
      .product-item {
        .detail-wrap {
          flex-direction: row;
          .right {
            text-align: start;
            margin-left: 20px;
            font-size: 20px;
            .top-bar {
              display: flex;
              flex-direction: row;
              align-items: flex-start;
            }
            .product-price {
              display: inline-block;
              color: $themeColor;
            }
          }
        }
      }
      .product-item + .product-item {
        margin-top: 20px;
        margin-left: 0;
      }
    }
  }
  .fold-icon {
    cursor: pointer;
    display: block;
    margin: 0 auto;
    width: 41px;
    height: 36px;
    &.active {
      transform: rotate(180deg);
    }
  }
  .extra-wrap {
    font-size: 20px;
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
}
</style>
